import { useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { BottomTabBar } from './BottomTabBar';
import { useDisplaySettings } from '../api/hooks';
import { useIsPhone } from '../hooks/useMediaQuery';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { data: displaySettings } = useDisplaySettings();
  const isPhone = useIsPhone();

  // Apply theme class to document when settings load or change
  useEffect(() => {
    const theme = displaySettings?.theme || 'light';
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [displaySettings?.theme]);

  return (
    <div className="flex h-screen bg-bg-primary">
      {/* Sidebar Navigation - hidden on phone */}
      {!isPhone && <Sidebar />}

      {/* Main Content - add bottom padding on phone for tab bar clearance */}
      <main className={`flex-1 overflow-auto ${isPhone ? 'pb-[72px]' : ''}`}>
        {children}
      </main>

      {/* Bottom Tab Bar - only on phone */}
      <BottomTabBar />
    </div>
  );
}
